module.exports = __webpack_public_path__ + "d94e20c1/img/share-action-icon.9c12578c.svg";